export default __webpack_public_path__ + "static/media/startmed-hosp.253ed50c.png";